

import React from "react";
import { CssBaseline } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { useAuth } from "./context/AuthContext";

import { AppProvider } from "./context/AppContext";
import { FeaturesProvider } from "./context/PermissionsAndFeatures/FeaturesContext";
import { PermissionsProvider } from "./context/PermissionsAndFeatures/UserPermissionsContext";
import { SettingsProvider } from "./context/SettingsContext";
import { ProductProvider } from "./context/OrderCreator/ProductContext";
import { TablesProvider } from "./context/OrderCreator/TablesContext";
import { OrderProvider } from "./context/OrderCreator/TablesContext/OrderContext";
import { InvoiceProvider } from "./context/OrderCreator/TablesContext/InvoiceCreator";

const App = () => {
  const { loading } = useAuth();

  // ⛔ مهم جدًا: انتظر تحميل auth فقط
  if (loading) {
    return <div>Loading...</div>; // أو Spinner
  }

  return (
    <>
      <CssBaseline />

      <FeaturesProvider>
        <PermissionsProvider>
          <SettingsProvider>
            <ProductProvider>
              <TablesProvider>
                <OrderProvider>
                  <InvoiceProvider>
                    <AppProvider>
                      {/* ✅ التحكم في الدخول يتم فقط داخل Routes */}
                      <AppRoutes />
                    </AppProvider>
                  </InvoiceProvider>
                </OrderProvider>
              </TablesProvider>
            </ProductProvider>
          </SettingsProvider>
        </PermissionsProvider>
      </FeaturesProvider>
    </>
  );
};

export default App;
